var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 44,
    viewBox: "0 0 98 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    width: 79.7865,
    height: 9.38665,
    rx: 4.69332,
    fill: "url(#paint0_linear_1180_5613)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 8.80078,
    y: 17.3066,
    width: 79.7865,
    height: 9.38665,
    rx: 4.69332,
    fill: "url(#paint1_linear_1180_5613)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 18.1875,
    y: 34.6134,
    width: 79.7865,
    height: 9.38665,
    rx: 4.69332,
    fill: "url(#paint2_linear_1180_5613)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1180_5613",
    x1: -3.71534e-8,
    y1: 4.69333,
    x2: 79.7865,
    y2: 4.69333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1180_5613",
    x1: 8.80078,
    y1: 22,
    x2: 88.5873,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58E0E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0253A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1180_5613",
    x1: 18.1875,
    y1: 39.3067,
    x2: 97.974,
    y2: 39.3067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575757"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/LogoMini.338ae9002f6598237a86aec9f938309a.svg";
export { ForwardRef as ReactComponent };